module.exports = __webpack_public_path__ + "img/subroot-left.7f4ec5dd.svg";